import { render, staticRenderFns } from "./edit-role-dialog.vue?vue&type=template&id=155567d8&scoped=true"
import script from "./edit-role-dialog.vue?vue&type=script&lang=js"
export * from "./edit-role-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-role-dialog.vue?vue&type=style&index=0&id=155567d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155567d8",
  null
  
)

export default component.exports